import Vue from 'vue'
import Vuex from 'vuex'

import globalModule from './globalModule'
import TaskNotificationsStore from './TaskNotificationsStore'
import concurrentRequestsStore from './concurrentRequestsStore'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    global: globalModule,
    taskNotifications: TaskNotificationsStore,
    concurrentRequestsStore
  }
})
